export default __webpack_public_path__ + "static/media/Refresh.a83df568.png";